import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDownIcon, ChevronRightIcon, DocumentTextIcon, QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./P2pTrading.css";

const orderStatuses = ["All", "Unpaid", "Paid", "Appeal in Progress"];

const P2pOrder = ({ embedded = false }) => {
  const [activeTab, setActiveTab] = useState("processing");
  const [orderTab, setOrderTab] = useState("all");

  return (
    <div className="p2p-page p2p-orders-page">
      {!embedded && <Header />}
      <div className="p2p-subnav">
        <div className="p2p-subnav-inner">
          <div className="p2p-market-tabs">
            <Link to="/p2ptrading">P2P</Link>
            <button type="button" disabled>Express</button>
            <button type="button" disabled>Block</button>
          </div>
          <nav>
            <Link to="/support-center"><QuestionMarkCircleIcon />P2P Help Center<ChevronDownIcon /></Link>
            <Link to="/p2p-order"><DocumentTextIcon />Orders</Link>
            <Link to="/account"><span className="p2p-nav-avatar">U</span>User Center</Link>
          </nav>
        </div>
      </div>

      <main className="p2p-main p2p-orders-main">
        <h1>Orders</h1>
        <div className="p2p-order-primary-tabs" role="tablist" aria-label="Order views">
          {[ ["processing", "Processing"], ["all", "All Orders"] ].map(([value, label]) => (
            <button type="button" role="tab" aria-selected={activeTab === value} key={value} onClick={() => setActiveTab(value)} className={activeTab === value ? "selected" : ""}>{label}</button>
          ))}
        </div>

        <div className="p2p-order-status-tabs" aria-label="Filter by order status">
          {orderStatuses.map((item) => {
            const value = item.toLowerCase();
            return <button type="button" key={item} onClick={() => setOrderTab(value)} className={orderTab === value ? "selected" : ""}>{item}</button>;
          })}
        </div>

        <div className="p2p-order-filters">
          <select aria-label="Filter by coin"><option>All coins</option><option>BTC</option><option>ETH</option></select>
          <select aria-label="Filter by fiat currency"><option>All currencies</option><option>USD</option><option>INR</option></select>
          <select aria-label="Filter by side"><option>All sides</option><option>Buy</option><option>Sell</option></select>
          <input type="search" placeholder="Search order no." aria-label="Search order number" />
          <button type="button" onClick={() => { setOrderTab("all"); }}>Reset</button>
        </div>

        <section className="p2p-order-table" aria-label="P2P orders">
          <div className="p2p-order-table-head"><span>Type / Date</span><span>Order number</span><span>Price</span><span>Fiat / Crypto Amount</span><span>Counterparty</span><span>Status</span><span /></div>
          <div className="p2p-orders-empty"><span className="p2p-orders-empty-icon"><DocumentTextIcon /></span><strong>No records</strong><span>Your P2P orders will appear here.</span><Link to="/p2ptrading">Start trading <ChevronRightIcon /></Link></div>
        </section>
      </main>
      {!embedded && <Footer />}
    </div>
  );
};

export default P2pOrder;
